import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navigation } from '@/components/layout/Navigation';
import { Sidebar } from '@/components/layout/Sidebar';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { BacktestHistoryView } from '@/components/trading/BacktestHistoryView';
import { BloombergRadioButton } from '@/components/trading/BloombergRadioButton';

const BacktestHistory = () => {
  const navigate = useNavigate();
  const [activeView] = useState('trader');
  const [showRoles] = useState(false);
  
  return (
    <div className="bg-gray-50 min-h-screen flex flex-col w-full">
      <Navigation 
        activeView={activeView}
        setActiveView={() => {}}
        showRoles={showRoles}
        setShowRoles={() => {}}
      />
      <div className="flex-1 flex">
        <div className="hidden md:block">
          <Sidebar />
        </div>
        <main className="flex-1 relative p-6 pb-16 w-full max-w-[1920px] mx-auto">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => navigate(-1)}
                className="mr-1"
              >
                <ArrowLeft className="h-5 w-5" />
              </Button>
              <h1 className="text-2xl font-semibold">Backtest History</h1>
            </div>
          </div>
          <BacktestHistoryView />
        </main>
      </div>
      
      {/* Bloomberg Radio Button */}
      <div className="fixed bottom-4 right-4 z-50">
        <BloombergRadioButton />
      </div>
    </div>
  );
};

export default BacktestHistory; 